import type { FunctionComponent } from 'react';

import { IssueScopeKind } from '../../../../../shared/issuesV2';
import SBOMSection from '../../../shared/settings/SettingsPageSBOMSection';
import Section from '../../../shared/settings/SettingsPageSection';

import type { SBOMProjectSettings } from './useSBOMProjectSettings';

/**
 * ProjectSBOMPoliciesSettings component displays a settings section to configure the SBOM policy
 */
const ProjectSBOMPoliciesSettings: FunctionComponent<SBOMProjectSettings> = ({
  policyOptions,
  selectedPolicyOption,
  onSelectedPolicyChange,
  canEditPolicy,
  sbomAnalysisEnabled,
  setSBOMAnalysisEnabled,
}: SBOMProjectSettings) => {
  return (
    <Section>
      <Section.Left heading="SBOM">
        <Section.Paragraph>Configuration for the SBOMs imported to this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <SBOMSection
          scopeType={IssueScopeKind.Project}
          sbomAnalysisEnabled={sbomAnalysisEnabled}
          onToggleSBOMAnalysis={setSBOMAnalysisEnabled}
          policyOptions={policyOptions}
          selectedPolicyOption={selectedPolicyOption}
          onSelectedPolicyChange={onSelectedPolicyChange}
          canEditPolicy={canEditPolicy}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectSBOMPoliciesSettings;
